import './_product-grid.scss';
import component from './product-grid';

export default component;
